import React from 'react';
import { Icon } from './Icon.js';
export const IconAngleDottedFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M15.25,16H4.75c-1.517,0-2.75-1.233-2.75-2.75V2.75c0-.414,.336-.75,.75-.75s.75,.336,.75,.75V13.25c0,.689,.561,1.25,1.25,1.25H15.25c.414,0,.75,.336,.75,.75s-.336,.75-.75,.75Z", fill: "currentColor" }),
        React.createElement("circle", { cx: "5.429", cy: "8.783", r: ".75", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("circle", { cx: "7.7", cy: "10.3", r: ".75", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("circle", { cx: "9.217", cy: "12.571", r: ".75", fill: "currentColor", "data-color": "color-2" })));
};
//# sourceMappingURL=IconAngleDottedFill18.js.map